export default Object.freeze({
  location: 'LOCATION',
  client: 'CLIENT',
  clientGroup: 'CLIENT_GROUP',
})
